/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $GraphicsBox, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {Graphics as PixiGraphics} from 'pixi.js';
import {COLOR_POPUP_BG, DISABLED_ALPHA} from '@gongxigames/framework/slotV2/ui/ui-ruby/CONSTANTS';
import {createFaderTween} from './functions';

export type BasePopupFaderProps = {
    show: boolean;
    // action?: () => {};
};

export type PopupFaderProps = CanBeSignals<BasePopupFaderProps>;

export const $PopupFader: FC<PopupFaderProps> = (props) => {
    const fader = new PixiGraphics();

    createFaderTween(props, fader);

    return <$GraphicsBox
        interactive
        visible={props.show}
        instance={fader}
        name='popupFader'
        responsive={{
            box: {width: '100%', height: '100%', x: '-50%', y: '-50%'}
        }}
        responsiveBoxSize
        boxColor={COLOR_POPUP_BG}
        boxAlpha={DISABLED_ALPHA}
    />;
};
